import Ajax from './ajax';
import Order from '../domain/order';
import { LOGGED_OFF } from './authentication';
import { cloneDeep } from 'lodash';
import { toast } from 'react-toastify';
import i18next from 'i18next';
import { DELIVERY_DATE_INFO_LOADED } from './prodplanningdata';
import { mergeAutosaveResult } from './orderautosavemerge';

export const FETCH_ORDER_DATA_REQ = 'customerorderdata/FETCHORDERDATAREQ';
export const FETCH_ORDER_DATA_COMPLETED = 'customerorderdata/FETCHORDERDATACOMPLETED';
export const FETCH_ORDER_DATA_FAILED = 'customerorderdata/FETCHORDERDATAFAILED';

export const SAVING_ORDER = 'customerorderdata/SAVINGORDER';
export const ORDER_SAVED = 'customerorderdata/ORDERSAVED';
export const ORDER_SAVE_FAILED = 'customerorderdata/ORDERSAVEFAILED';

export const SAVING_COMBINED_ORDER = 'customerorderdata/SAVINGCOMBINEDORDER';
export const SAVING_COMBINED_ORDER_SUCCESS = 'customerorderdata/SAVINGCOMBINEDORDERSUCCESS';
export const SAVING_COMBINED_ORDER_FAIL = 'customerorderdata/SAVINGCOMBINEDORDERFAIL';

export const REMOVE_ORDER = 'customerorderdata/REMOVEORDER';

export const SENDING_ORDERS = 'customerorderdata/SENDINGORDERS';
export const SEND_ORDERS_SUCCESS = 'customerorderdata/SENDORDERSSUCCESS';
export const SEND_ORDERS_FAILED = 'customerorderdata/SENDORDERSFAILED';

export const FETCH_ORDER_BY_ORDER_NUMBER = 'customerorderdata/ORDER_BY_ORDER_NUMBER';
export const FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS = 'customerorderdata/ORDER_BY_ORDER_NUMBER_SUCCESS';
export const FETCH_ORDER_BY_ORDER_NUMBER_FAIL = 'customerorderdata/ORDER_BY_ORDER_NUMBER_FAIL';

export const SAVE_PENDING_ORDER = 'custorderdata/SAVE_PENDING_ORDER';

export const AUTOSAVING = 'custorderdata/AUTOSAVING';
export const AUTOSAVING_DONE = 'custorderdata/AUTOSAVING_DONE';
export const AUTOSAVING_FAILED = 'customerorderdata/AUTOSAVING_FAILED';

export const DataSaveStatus = {
    Saving: 1,
    SaveSuccess: 2,
    SaveFailed: 3,
};

export const OrderSendStatus = {
    Sending: 1,
    SendSuccessful: 2,
    SendFailed: 3,
};

const initialState = {
    pendingOrders: null,
    isFetchingOrderData: false,
    fetchOrderDataFailed: false,
    orderSaveStatus: {},
    orderSavingInProgress: false,
    sendingOrdersInProgress: false,
    orderSendFailed: false,
    savingCombinedOrder: false,
    ordersByOrderNumber: {}, // would contain e.g. 12345: [order1, order2,..]
    autosaving: {},
    autosavingFailed: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ORDER_DATA_REQ:
            return {
                ...state,
                isFetchingOrderData: true,
                fetchOrderDataFailed: false,
            };
        case FETCH_ORDER_DATA_COMPLETED:
            const orderList = [];
            for (const o of action.orders) {
                orderList.push(new Order(o));
            }
            return {
                ...state,
                pendingOrders: orderList,
                isFetchingOrderData: false,
                fetchOrderDataFailed: false,
            };
        case FETCH_ORDER_DATA_FAILED:
            return {
                ...state,
                actions: [],
                isFetchingOrderData: false,
                fetchOrderDataFailed: true,
            };
        case SAVING_ORDER: {
            let newStatus = Object.assign({}, state.orderSaveStatus);
            if (action.id != null) newStatus[action.id] = DataSaveStatus.Saving;
            return {
                ...state,
                orderSaveStatus: newStatus,
                orderSavingInProgress: true,
            };
        }
        case ORDER_SAVED: {
            let newStatus = Object.assign({}, state.orderSaveStatus);
            let newPendingOrderList = [];
            if (action.multiple === true) {
                for (let o of state.pendingOrders) {
                    let newInd = 0;
                    let addOld = true;
                    for (let newOrder of action.orders) {
                        if (newOrder.id === o.id) {
                            newPendingOrderList.push(new Order(newOrder));
                            addOld = false;
                            action.orders.splice(newInd, 1);
                            break;
                        }
                        newInd++;
                    }
                    if (addOld) newPendingOrderList.push(o);
                }
                if (action.orders.length > 0) {
                    for (let o of action.orders) {
                        newPendingOrderList.push(new Order(o));
                    }
                }
            } else {
                newStatus[action.order.id] = DataSaveStatus.SaveSuccess;
                let addOrderAsNew = true;
                for (let o of state.pendingOrders) {
                    if (o.id === action.order.id) {
                        newPendingOrderList.push(new Order(action.order));
                        addOrderAsNew = false;
                    } else {
                        newPendingOrderList.push(o);
                    }
                }
                if (addOrderAsNew) newPendingOrderList.push(new Order(action.order));
            }

            return {
                ...state,
                pendingOrders: newPendingOrderList,
                orderSaveStatus: newStatus,
                orderSavingInProgress: false,
            };
        }
        case ORDER_SAVE_FAILED: {
            let newStatus = Object.assign({}, state.orderSaveStatus);
            if (action.id != null) newStatus[action.id] = DataSaveStatus.SaveFailed;
            return {
                ...state,
                orderSaveStatus: newStatus,
                orderSavingInProgress: false,
            };
        }
        case REMOVE_ORDER: {
            let newPendingOrderList = [];
            for (let o of state.pendingOrders) {
                if (o.id !== action.id) {
                    newPendingOrderList.push(o);
                }
            }
            return {
                ...state,
                pendingOrders: newPendingOrderList,
            };
        }
        case SENDING_ORDERS: {
            return {
                ...state,
                orderSendFailed: false,
                sendingOrdersInProgress: true,
            };
        }
        case SEND_ORDERS_SUCCESS: {
            const sentIds = action.orders.map((o) => o.id);
            const orderList = state.pendingOrders.filter((o) => !sentIds.includes(o.id));
            return {
                ...state,
                orderSendFailed: false,
                pendingOrders: orderList,
                sendingOrdersInProgress: false,
            };
        }
        case SEND_ORDERS_FAILED: {
            return {
                ...state,
                orderSendFailed: true,
                sendingOrdersInProgress: false,
            };
        }
        case SAVING_COMBINED_ORDER: {
            return {
                ...state,
                savingCombinedOrder: true,
            };
        }
        case SAVING_COMBINED_ORDER_SUCCESS: {
            return {
                ...state,
                savingCombinedOrder: false,
            };
        }
        case SAVING_COMBINED_ORDER_FAIL: {
            return {
                ...state,
                savingCombinedOrder: false,
            };
        }
        case FETCH_ORDER_BY_ORDER_NUMBER:
            return state;
        case FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS: {
            let newOrderList = cloneDeep(state.ordersByOrderNumber);
            newOrderList[action.orderNumber] = action.orders.map((item) => {
                return new Order(item);
            });
            return {
                ...state,
                ordersByOrderNumber: newOrderList,
            };
        }
        case FETCH_ORDER_BY_ORDER_NUMBER_FAIL:
            return state;
        case AUTOSAVING: {
            const newAutosaving = cloneDeep(state.autosaving);
            newAutosaving[action.orderId] = true;
            const newAutosavingFailed = cloneDeep(state.autosavingFailed);
            delete newAutosavingFailed[action.orderId];
            return {
                ...state,
                autosaving: newAutosaving,
                autosavingFailed: newAutosavingFailed,
            };
        }
        case AUTOSAVING_DONE: {
            const newAutosaving = cloneDeep(state.autosaving);
            delete newAutosaving[action.orderId];
            const newAutosavingFailed = cloneDeep(state.autosavingFailed);
            delete newAutosavingFailed[action.orderId];
            return {
                ...state,
                autosaving: newAutosaving,
                autosavingFailed: newAutosavingFailed,
            };
        }
        case AUTOSAVING_FAILED: {
            const newAutosaving = cloneDeep(state.autosaving);
            delete newAutosaving[action.orderId];
            const newAutosavingFailed = cloneDeep(state.autosavingFailed);
            newAutosavingFailed[action.orderId] = true;
            return {
                ...state,
                autosaving: newAutosaving,
                autosavingFailed: newAutosavingFailed,
            };
        }
        case SAVE_PENDING_ORDER: {
            let newPendingOrderList = [];
            for (let o of state.pendingOrders) {
                if (o.id === action.order.id) {
                    newPendingOrderList.push(new Order(action.order));
                } else {
                    newPendingOrderList.push(o);
                }
            }
            return {
                ...state,
                pendingOrders: newPendingOrderList,
            };
        }
        case LOGGED_OFF:
            return initialState;
        default:
            return state;
    }
};

export const saveOrderToStore = (order) => {
    return (dispatch) => {
        dispatch({
            type: SAVE_PENDING_ORDER,
            order: order,
        });
    };
};

export const autosaveOrder = (order) => {
    return async (dispatch, getState) => {
        dispatch({ type: AUTOSAVING, orderId: order.id });
        const sentSnapshot = cloneDeep(order);
        try {
            var resp = await Ajax.put('api/customerorder/autosave/' + order.id, order);
            const currentOrder = getState().customerorderdata.pendingOrders.find((o) => o.id === order.id);
            if (currentOrder != null && resp.data.updatedOrder != null) {
                const merged = mergeAutosaveResult(cloneDeep(currentOrder), sentSnapshot, resp.data.updatedOrder);
                dispatch(saveOrderToStore(merged));
            }
            if (resp.data.capacityUpdateFailed) {
                dispatch({ type: AUTOSAVING_FAILED, orderId: order.id });
            } else {
                dispatch({ type: AUTOSAVING_DONE, orderId: order.id });
            }
            dispatch({
                type: DELIVERY_DATE_INFO_LOADED,
                orderIds: [order.id],
                deliveryInfos: resp.data.earliestDeliveryDates,
            });
        } catch (err) {
            console.log(err);
            dispatch({ type: AUTOSAVING_FAILED, orderId: order.id });
        }
    };
};

export const getPendingOrders = () => {
    return (dispatch) => {
        dispatch({
            type: FETCH_ORDER_DATA_REQ,
        });
        Ajax.get('api/customerorder/draft/')
            .then(function (data) {
                dispatch({
                    type: FETCH_ORDER_DATA_COMPLETED,
                    orders: data.data.draftOrders,
                });
            })
            .catch(function (err) {
                dispatch({
                    type: FETCH_ORDER_DATA_FAILED,
                });
            });
    };
};

export const removeOrder = (id) => {
    return (dispatch) => {
        Ajax.delete('api/customerorder/' + id)
            .then(function (res) {
                dispatch({
                    type: REMOVE_ORDER,
                    id: id,
                });
            })
            .catch(function (err) {
                console.log(err);
            });
    };
};

const sendOrdersInternal = (orders, combine, dispatch, language) => {
    dispatch({
        type: SENDING_ORDERS,
        orders: orders,
    });
    const url = combine ? 'api/customerorder/sendcombined/' : 'api/customerorder/send/';
    Ajax.post(url, { orders, language })
        .then(function (res) {
            dispatch({
                type: SEND_ORDERS_SUCCESS,
                orders: orders,
            });
            dispatch(getPendingOrders());
        })
        .catch(function (err) {
            console.log(err);
            dispatch({
                type: SEND_ORDERS_FAILED,
                orders: orders,
            });
        });
};

export const sendOrdersCombined = (orders, language) => {
    return (dispatch) => {
        return sendOrdersInternal(orders, true, dispatch, language);
    };
};

export const sendOrders = (orders, language) => {
    return (dispatch) => {
        sendOrdersInternal(orders, false, dispatch, language);
    };
};

export const newOrderFromLocation = (locationId, actionId) => {
    return (dispatch, getState) => {
        toastInfo('toast.addingLocationToOrder');
        dispatch({
            type: SAVING_ORDER,
            id: null,
        });
        Ajax.post('api/customerorder/fromlocation/' + locationId + '/actionid/' + actionId, {})
            .then(function (res) {
                toastInfo('toast.addedLocationToOrder');
                dispatch({
                    type: ORDER_SAVED,
                    order: res.data,
                });
            })
            .catch(function (err) {
                toastError('toast.addingLocationToOrderFailed');
                dispatch({
                    type: ORDER_SAVE_FAILED,
                    id: null,
                });
            });
    };
};

export const addMachineToOrder = (locId, machineId) => {
    return (dispatch) => {
        toastInfo('toast.addingMachineToOrder');
        dispatch({
            type: SAVING_ORDER,
            id: null,
        });
        Ajax.post('api/customerorder/' + locId + '/' + machineId)
            .then(function (res) {
                toastInfo('toast.addedMachineToOrder');
                dispatch({
                    type: ORDER_SAVED,
                    order: res.data,
                });
            })
            .catch(function (err) {
                toastError('toast.addingMachineToOrderFailed');
                dispatch({
                    type: ORDER_SAVE_FAILED,
                    id: null,
                });
            });
    };
};

export const addFilterToOrder = (locationId, machineId, filterId) => {
    return (dispatch) => {
        toastInfo('toast.addingFilterToOrder');
        dispatch({
            type: SAVING_ORDER,
            id: null,
        });
        Ajax.post('api/customerorder/' + locationId + '/' + machineId + '/' + filterId)
            .then(function (res) {
                toastInfo('toast.addedFilterToOrder');
                dispatch({
                    type: ORDER_SAVED,
                    order: res.data,
                });
            })
            .catch(function (err) {
                toastError('toast.addingFilterToOrderFailed');
                dispatch({
                    type: ORDER_SAVE_FAILED,
                    id: null,
                });
            });
    };
};

export const allocatePalletsForOrders = (orderIds) => {
    return (dispatch) => {
        toastInfo('toast.allocatingPalletsToOrder');
        dispatch({
            type: SAVING_ORDER,
            id: null,
        });
        Ajax.put('api/customerorder/allocatepallets/', orderIds)
            .then(function (res) {
                toastInfo('toast.allocatedPalletsToOrder');
                dispatch({
                    type: ORDER_SAVED,
                    multiple: true,
                    orders: res.data,
                });
            })
            .catch(function (err) {
                toastError('toast.allocatingPalletsToOrderFailed');
                dispatch({
                    type: ORDER_SAVE_FAILED,
                    id: null,
                });
            });
    };
};

export const newOrderFromLocations = (locationIds) => {
    return (dispatch, getState) => {
        toastInfo('toast.addingLocationToOrder');
        dispatch({
            type: SAVING_ORDER,
            id: null,
        });
        Ajax.post('api/customerorder/fromlocations/', locationIds)
            .then(function (res) {
                toastInfo('toast.addedLocationToOrder');
                dispatch({
                    type: ORDER_SAVED,
                    multiple: true,
                    orders: res.data,
                });
            })
            .catch(function (err) {
                toastError('toast.addingLocationToOrderFailed');
                dispatch({
                    type: ORDER_SAVE_FAILED,
                    id: null,
                });
            });
    };
};

export const getOrdersByOrderNumber = (orderNumber) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_ORDER_BY_ORDER_NUMBER });
        try {
            const resp = await Ajax.get('api/customerorder/ordernumber/' + orderNumber);
            dispatch({
                type: FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS,
                orders: resp.data,
                orderNumber: orderNumber,
            });
        } catch (err) {
            console.log(err.toJSON());
            dispatch({ type: FETCH_ORDER_BY_ORDER_NUMBER_FAIL });
        }
    };
};

// Customer-portal counterpart of orderdata.js's getBlockedDeliveryMethods - the equivalent
// api/order endpoint requires SalesRole, which customer-portal users don't have.
export const getBlockedDeliveryMethods = async (zipCode) => {
    if (!zipCode) return [];
    try {
        const resp = await Ajax.get('api/customerorder/blockeddeliverymethods/' + zipCode);
        return resp.data;
    } catch (err) {
        console.log(err);
        return [];
    }
};

const toastInfo = (message) => {
    toast.info(i18next.t(message), { timeout: 1000, hideProgressBar: true });
};

const toastError = (message) => {
    toast.error(i18next.t(message), { timeout: 5000 });
};
